import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../../components/components"
import Zahlungsbedingung from "../../../models/zahlungsbedingung"
import { FeatureService } from "../../../services/FeatureService"
import { eventhandlingForLists } from "../../hooks/EventhandlingForLists"
import { ZahlungsbedingungKomplexEintragView } from "./ZahlungsbedingungKomplexEintragView"
import { useStoreRechnung } from "../../../store"

interface ZahlungsbedingungenKomplexListViewProps {
    typ: "SKONTO" | "VERZUG"
    path?: string
}

export function ZahlungsbedingungenKomplexListView({ typ, path = "zahlungsdaten.zahlungsbedingungen" }: ZahlungsbedingungenKomplexListViewProps) {
    const {
        zahlungsdaten: { zahlungsbedingungen: bedingungen },
    } = useStoreRechnung("zahlungsdaten")

    const { t } = useTranslation()
    const title = typ === "SKONTO" ? t("rechnung.zahlungsdaten.zahlungsbedingungen.skonto.label") : t("rechnung.zahlungsdaten.zahlungsbedingungen.verzug.label")
    const addButtonLabel =
        typ === "SKONTO"
            ? t("rechnung.zahlungsdaten.zahlungsbedingungen.skonto.hinzufuegen")
            : t("rechnung.zahlungsdaten.zahlungsbedingungen.verzug.hinzufuegen")

    const createZahlungsbedingung = () => {
        const bedingung = new Zahlungsbedingung()
        bedingung.typ = typ
        bedingung.tage = 14
        return bedingung
    }

    const { add, remove, onChange } = eventhandlingForLists(path, createZahlungsbedingung)
    const hatBedingungenVomTyp = bedingungen && bedingungen.filter((b) => b.typ === typ).length > 0
    const disabled = FeatureService.isFeatureActive("DEMO")

    return (
        <Components.Collapsible title={title} collapsed={false}>
            {!disabled &&
                bedingungen &&
                bedingungen.map((bedingung, index) => (
                    <ZahlungsbedingungKomplexEintragView key={index} typ={typ} bedingung={bedingung} onChange={onChange(index)} onRemove={remove(index)} />
                ))}

            <Components.Row>
                {hatBedingungenVomTyp && (
                    <Components.Col align={Components.Align.LEFT} size={9} sizeSmallDown={12}>
                        {!disabled && <label>{t("rechnung.zahlungsdaten.zahlungsbedingungen.hinweis")}</label>}
                    </Components.Col>
                )}
                <Components.Col align={Components.Align.RIGHT} size={hatBedingungenVomTyp ? 3 : 12} sizeSmallDown={12}>
                    <Components.Button
                        id={typ}
                        style={Components.ButtonStyle.SECONDARY}
                        label={addButtonLabel}
                        onClick={add}
                        disabled={disabled}
                        tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                        tooltipAtDisabled={disabled}
                    />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
